import { Screen } from "./components";
import { C } from "./tokens";

export function Spinner() {
  return (
    <Screen style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div style={{
        width: 36, height: 36, position: "relative",
      }}>
        <div style={{
          position: "absolute", inset: 0, borderRadius: "50%",
          background: "conic-gradient(from 0deg, transparent 0deg, rgba(255,255,255,0.7) 80deg, transparent 120deg)",
          WebkitMask: "radial-gradient(circle, transparent 14px, #000 15px)",
          mask: "radial-gradient(circle, transparent 14px, #000 15px)",
          animation: "spespin 1.0s linear infinite",
        }} />
        <div style={{
          position: "absolute", inset: 0, borderRadius: "50%",
          border: `1px solid ${C.border}`,
        }} />
      </div>
    </Screen>
  );
}
